import apiClient, {timeouts} from 'shared/services/apiClient';
import {PVRResp} from "../types";
import {endpoints} from "shared/services/endpoints";

export const pvrService = {
    getPVR: async (cat_num: number) => {
        return apiClient
            .get<PVRResp>(endpoints.pvr.byCategory(cat_num), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as PVRResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as PVRResp;
            }
        );
    },
};
